module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e115c935d344a357cee1b0ba440638b0.png";